import React, { useContext, useMemo, useState } from "react";
import { createSelectorHooks } from "auto-zustand-selectors-hook";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

// import ChangePasswordDialog from "src/app/pages/ChangePassword";
// import { DigitalSignature } from "src/app/pages/DigitalSignature";
import { toAbsoluteUrl } from "@helpers/AssetsHelpers";
import { useAbortableEffects } from "@helpers/useAbortableEffects";
import { Avatar } from "@material-ui/core";
import { AbilityContext } from "@metronic/_context/Can";
import useStoreUserRoles from "@src/app/_storeUserRoles";
import ChangePasswordDialog from "@src/app/pages/change-password/ChangePassword";
import { DigitalSignature } from "@src/app/pages/digital-signature/DigitalSignature";
import useAppMenus from "@src/app/pages/home/AppMenus";
import { ARCHEM_APPS } from "@src/app/pages/home/ArchemApps";

import { useHtmlClassService } from "../../../_core/MetronicLayout";

import { AsideMenuList } from "./AsideMenuList";
// hook to check the app version on route change
function useVersionCheck() {
  // check if a version update (refresh) needed on route change
  let location = useLocation();
  React.useLayoutEffect(() => {
    // if there is an update available and no state passed to route
    if (!location.state && window.localStorage.getItem('version-update-needed')) {
      window.localStorage.removeItem('version-update-needed'); // remove the storage object
      window.location.reload(); // refresh the browser
    }
  }, [location]);
};

export function AsideMenu({ disableScroll }) {
  const ability = useContext(AbilityContext);
  // const navigate = useNavigate();
  const { pathname } = useLocation();
  const [setCurrentApplication] = useAppMenus();
  const _store = createSelectorHooks(useStoreUserRoles);
  const __setApplication = _store.useSetApplication();
  const [showSignature, setShowSignature] = useState(false)
  const [openChangePassword, setOpenChangePassword] = useState(false)

  useAbortableEffects(() => {
    if (pathname.startsWith('/tradesummary')) {
      setCurrentApplication(ARCHEM_APPS.TRADE_SUMMARY.title);
    } else if (pathname.startsWith('/logistics')) {
      setCurrentApplication(ARCHEM_APPS.LOGISTICS.title);
    } else if (pathname.startsWith('/tanksounding')) {
      setCurrentApplication(ARCHEM_APPS.TANK_SOUNDING.title);
    } else if (pathname.startsWith('/rawmats')) {
      setCurrentApplication(ARCHEM_APPS.RAW_MATS.title);
    } else if (pathname.startsWith('/nonrawmats')) {
      setCurrentApplication(ARCHEM_APPS.NON_RAW_MATS.title);
    } else if (pathname.startsWith('/salescontract')) {
      setCurrentApplication(ARCHEM_APPS.SALES_CONTRACT.title);
    } else if (pathname.startsWith('/ucap')) {
      setCurrentApplication(ARCHEM_APPS.UCAP.title);
    } else if (pathname.startsWith('/home')) {
      setCurrentApplication('');
      __setApplication('HOME')
    } else if (pathname.startsWith('/maintenance')) {
      setCurrentApplication(ARCHEM_APPS.SETTINGS.title);
    }
  }, [pathname, ability])

  useVersionCheck();

  // const [hiddenSignature, { toggle: toggleDigitalSignature }] = useBoolean(true);

  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      layoutConfig: uiService.config,
      asideMenuAttr: uiService.getAttributes("aside_menu"),
      ulClasses: uiService.getClasses("aside_menu_nav", true),
      asideClassesFromConfig: uiService.getClasses("aside_menu", true)
    };
  }, [uiService]);

  const { currentUser } = useSelector(
    (state) => ({
      currentUser: state?.auth?.user?.user,
    })
  );

  return (
    <>
      {/* <QueryClientProvider client={queryClient}> */}

      {/* begin::Menu Container */}
      <div
        id="kt_aside_menu"
        data-menu-vertical="1"
        className={`aside-menu my-4 ${layoutProps.asideClassesFromConfig}`}
        {...layoutProps.asideMenuAttr}
      >
        <div style={{ marginLeft: 20 }}>
          <Avatar className="menu-item notabsolute menu-user-custom" style={{ boxShadow: "0 1px 10px -5px #fff", display: 'inline-block' }} src={toAbsoluteUrl("/media/avatar/pp_boy4.svg")}></Avatar>
          <span className="menu-text notabsolute menu-custom-text user-avatar-details" >
            <p className="notabsolute pl12 d-block mb-0" style={{ color: '#FAFBFB', paddingLeft: 5, fontWeight: 400 }}>{currentUser && currentUser.fullname}<br />
              {/* <span className="notabsolute pl12 mtm2 d-block font-size-12 font-weight-lighter menu-custom-font-12">{currentUser && currentUser.username}</span> */}
            </p>
            <div style={{ display: 'flex' }}>
              {/* <ActionButton style={{ color: '#fff' }}>Change Settings</ActionButton> */}
              <div className="user-settings" style={{ paddingLeft: 5 }} onClick={() => setOpenChangePassword(true)}>Change Password</div>
              <div className="user-settings">&nbsp;|&nbsp;</div>
              <div className="user-settings" onClick={() => setShowSignature(true)} >Signature</div>
              {/* <Button onClick={() => {setOpenChangePassword(true);}} className="user-change-password" size="small" style={{ color: '#FAFBFB', textTransform: 'none', paddingBottom: 0, paddingTop: 0, fontWeight: 400 }} color="primary">
                                                        <i style={{ display: "inline-block", borderRadius: '50%', color: '#FAFBFB' }} />
                                                        Password
                                                </Button>              
                                                <div style={{color:'#fff'}}>|</div>
                                                <Button onClick={toggleDigitalSignature} className="user-change-password" size="small" style={{ color: '#FAFBFB', textTransform: 'none', paddingBottom: 0, paddingTop: 0, fontWeight: 400 }} color="primary">
                                                        <i style={{ display: "inline-block", borderRadius: '50%', color: '#FAFBFB' }} />
                                                        Signature
                                                </Button> */}
            </div>
          </span>
        </div>

        <AsideMenuList layoutProps={layoutProps} />

        {/* <div className="app-version">
          {process.env.REACT_APP_VERSION}
        </div> */}
      </div>
      {/* end::Menu Container */}

      <ChangePasswordDialog open={openChangePassword} setConfirmDialogOpen={() => setOpenChangePassword(false)} />
      <DigitalSignature isHidden={!showSignature} toggleSignatureDialog={() => { setShowSignature(false) }} />
      {/* </QueryClientProvider>     */}
    </>
  );
}
